import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import './dashboard.css';

const Dashboard = () => {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [counts, setCounts] = useState({});
  
  // All certificate categories except "Document Verification Form"
  const certificateCategories = [
    "Provisional Certificate",
    "Migration Certificate",
    "Bonafide Certificate",
    "Character Certificate",
    "Duplicate Certificate",
    "Internship Permission",
    "Consolidated Transcript Certificate",
    "Course Completion Certificate",
    "CGPA To Percentage Certificate"
  ];

  useEffect(() => {
    const isAuthenticated = sessionStorage.getItem('isLoggedIn');
    if (isAuthenticated !== 'true') {
      navigate('/login');
    }
  }, [navigate]);

  useEffect(() => {
    const fetchAllCounts = async () => {
      const updatedCounts = {};

      try {
        // Fetch count for "Document Verification Form"
        const docVerifyRes = await fetch("https://api.sgtu.ac.in/api/documentVerification/count");
        const docVerifyData = await docVerifyRes.json();
        updatedCounts["Document Verification Form"] = docVerifyData.count || 0;
      } catch (error) {
        console.error("Error fetching Document Verification count:", error);
        updatedCounts["Document Verification Form"] = 0;
      }

      // Fetch count for each certificate category
      for (let category of certificateCategories) {
        try {
          const res = await fetch(`https://api.sgtu.ac.in/api/sgtuCertificate/category/${encodeURIComponent(category)}`);
          const data = await res.json();
          updatedCounts[category] = data.count || 0;
        } catch (error) {
          console.error(`Error fetching count for ${category}:`, error);
          updatedCounts[category] = 0;
        }
      }

      setCounts(updatedCounts);
    };

    fetchAllCounts();
  }, []);

  // Create cards from counts object
  const cards = Object.entries(counts).map(([title, value]) => ({
    title,
    value,
  }));

  return (
    <div className="dashboard-wrapper">
      <Sidebar isSidebarOpen={isSidebarOpen} toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />
      <main className="dashboard-main">
        <Header />
        <div className="dashboard-cards">
          {cards.map((card, index) => (
            <div className="card" key={index}>
              <h2>{card.title}</h2>
              <p>{card.value}</p>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
};

export default Dashboard;